import {
  CitySelectField,
  InputDateField,
  InputField,
  InputNumberField,
  SelectField,
  StateSelectField,
  TextAreaField
} from './Fields';
import {
  FormItemCol,
  FormItemColProps
} from 'components/professor_area/FormItemCol';
import { IAttributeField } from 'interfaces/documentation/document-attribute-field';
import {
  IDENTITY_DOCUMENT_TYPE_FIELD,
  maxLengthDependencies,
  maxLengthRule
} from './max-length-rule';
import { useMemo } from 'react';

interface DocumentItemFieldProps {
  field: IAttributeField;
}

const FIELDS_MAP = {
  text: InputField,
  number: InputNumberField,
  select: SelectField,
  text_area: TextAreaField,
  state_select: StateSelectField,
  city_select: CitySelectField,
  date: InputDateField
};

const DEFAULT_FIELD = InputField;

interface DocumentItemFieldProps extends Partial<FormItemColProps> {
  field: IAttributeField;
  disabled?: boolean;
  // Prefixo do nome no formulário, para vários documentos no mesmo Form
  namePrefix?: string;
}

export const DocumentFieldItemCol = ({
  field,
  disabled,
  namePrefix = '',
  ...props
}: DocumentItemFieldProps) => {
  const { field_type, name, value, required, min, max } = field;
  const documentTypeName = `${namePrefix}${IDENTITY_DOCUMENT_TYPE_FIELD}`;

  const Component = useMemo(
    () => FIELDS_MAP[field_type] || DEFAULT_FIELD,
    [field_type]
  );

  const generateRules = () => {
    const rules = [];

    if (min) {
      rules.push({ min, message: `Mínimo ${min} caracteres` });
    }

    const maxRule = maxLengthRule({ name, max }, documentTypeName);

    if (maxRule) {
      rules.push(maxRule);
    }

    if (required) {
      rules.push({ required, message: 'Campo obrigatório' });
    }

    return rules;
  };

  const rules = useMemo(generateRules, [
    documentTypeName,
    max,
    min,
    name,
    required
  ]);

  return (
    <FormItemCol
      {...props}
      label={name} // Sempre mostra o nome original do campo
      name={`${namePrefix}${name}`}
      initialValue={value}
      rules={rules}
      dependencies={maxLengthDependencies(field, documentTypeName)}
    >
      <Component {...field} disabled={disabled} />
    </FormItemCol>
  );
};
